import React from 'react'
import { DialogTitle, DialogActions, DialogContent } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'
import ResponsiveDialog from 'app/components/dialog/ResponsiveDialog'
import useMobileStyle from 'app/components/mobileModal/mobileModalStyle'

export default (props) => {
  const { state, classes, toggleDialogs, deleteGroup, DELETE_GROUP_DIALOG } =
    props
  const mobileClasses = useMobileStyle()

  return (
    <ResponsiveDialog
      isFullScreen={false}
      className={clsx(classes.groupDialog, classes.groupDialogStyleOne)}
      open={state.isOpenDeleteGroupDialog}
    >
      <DialogTitle className={classes.groupDeleteTitle}>
        <FormattedMessage id="group.details.dialogs.deleteGroup" />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage id="group.dialog.desc1" />
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={() => {
            toggleDialogs(DELETE_GROUP_DIALOG, false)
          }}
          className={mobileClasses.modalBtn}
        />
        <DeleteButton
          onClick={deleteGroup}
          className={mobileClasses.modalBtn}
        />
      </DialogActions>
    </ResponsiveDialog>
  )
}
